import { render } from "./SectionProfile.vue?vue&type=template&id=0c2fdf0e&scoped=true"
import script from "./SectionProfile.vue?vue&type=script&lang=js"
export * from "./SectionProfile.vue?vue&type=script&lang=js"

import "./SectionProfile.vue?vue&type=style&index=0&id=0c2fdf0e&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2fdf0e"]])

export default __exports__